import { fetchJson, qs } from './base-roros.service';
import type { TreeResponse } from '@/types/roros/tree';

export const RorosTreeService = {
  getTree: (params?: { include_work_items?: boolean }): Promise<TreeResponse> => {
    const p: Record<string, string> = {};
    if (params?.include_work_items !== undefined) {
      p.include_work_items = String(params.include_work_items);
    }
    return fetchJson<TreeResponse>(
      `/api/v1/artifacts/tree${qs(Object.keys(p).length > 0 ? p : undefined)}`,
    );
  },
};
